import initializeForm from './initializeForm';
import openModal from './openModal';
import resetForm from './resetForm';

export default (id) => (dispatch) => {
    dispatch(resetForm());
    dispatch(openModal(true));
    dispatch(initializeForm({ id }));
};
